import { createContext } from 'react'

interface IScrollableElementContext {
  scrollableElementRef: React.RefObject<HTMLDivElement | null>
}

export const ScrollableElementContext =
  createContext<IScrollableElementContext>({
    scrollableElementRef: { current: null }
  })

interface IActiveTabContext {
  activeTabKey: string
  setActiveTabKey: (tabKey: string) => void
}

export const ActiveTabContext = createContext<IActiveTabContext>({
  activeTabKey: 'generate_tab_key',
  setActiveTabKey: () => {}
})
